var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExcelIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 8,
    fill: "#107C41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 27.5L16.295 18.475L10.987 9.5H15.259L18.156 15.237C18.423 15.78 18.606 16.187 18.706 16.454H18.743C18.936 16.019 19.135 15.597 19.343 15.186L22.44 9.5H26.362L20.917 18.425L26.5 27.5H22.328L18.98 21.198C18.8221 20.9304 18.6882 20.6493 18.58 20.358H18.531C18.473 20.558 18.344 20.831 18.144 21.174L14.697 27.5H10.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.6433bfbb.svg";
export { ForwardRef as ReactComponent };